import React, { Component } from "react";
import "../css/GoogleMapDialog.css";
import SimpleMap from "./Collapse/SimpleMap";
import { Translation } from "react-i18next";

class GoogleMapDialog extends Component {
  closeByBackground = e => {
    const { className } = e.target;
    if (className.includes("google-map-bg")) {
      // 點擊背景關閉視窗
      this.props.closeMapDialog();
    }
  };

  render() {
    const { showDialog, closeMapDialog, activeStore } = this.props;
    return (
      <div
        className={` ${
          showDialog ? "google-map-bg" : "google-map-bg google-map-bg-none"
        } `}
        onClick={this.closeByBackground}
      >
        <div
          className={` ${
            showDialog ? "google-map-content" : "google-map-content-drop"
          }`}
        >
          <div className="gm-close-button" onClick={closeMapDialog} />
          <div className="gm-header">
            <div className="gm-close-button-mobile" onClick={closeMapDialog} />
            <h2 className="google-map-title">
              <Translation>
                {t => <>{t("googleMapStoreLocation.storeLocation")}</>}
              </Translation>
            </h2>
          </div>
          <div className="gm-body">
            {showDialog && (
              <SimpleMap
                dsLatitude={activeStore && activeStore.dsLatitude}
                dsLongitude={activeStore && activeStore.dsLongitude}
              />
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default GoogleMapDialog;
